module.exports = __webpack_public_path__ + "static/img/kathi-mit-janosch-800x480.4cb590c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ueber-mich/kathi-mit-janosch-800x480.jpg
// module id = lYgO
// module chunks = 0